$(document).ready(function(){
	$(".auto_update_vtr").on("change",function(){
		temp 	= 	this.id.split("-")			;
		vtr_id	=	temp[temp.length -1 ]		;

		attributes	=	{}			;

		atter_name				=	"service_vehicle_track[" + temp[0] + "]"	;
		atter_value				=	this.value	;
		attributes[atter_name]	= 	atter_value	;
		
		var path = "/service_vehicle_tracks/" + vtr_id ;
		$.ajax({	url: 		path,
					type: 		"put",
					data: 		attributes,
					dataType: 	"json", 
					success: 	function(result){	},
	    			error: 		function (jqXHR, text, errorThrown) {	alert(jqXHR.responseJSON.error);	}
    			});
		
		
		
		
	});
	
	
	$(".update_vtr").on("click",function(){
		id = this.id	;
		
		if(check_blank(id)){
			update_vtr(id)	;
		}
		else{
			var myModal = new bootstrap.Modal(document.getElementById('confirm'), {keyboard: false});
			myModal.show()	;	
			
			$("#confirm-yes").on("click",function(){
				update_vtr(id)	;
				myModal.hide()	;
			});			
		}
		
		
	});
});

function check_blank(id){
	text_content = document.getElementById(id + "_dis").textContent	;
	is_blank = (text_content == "00:00" || text_content == "")	?	true	:false		;
	
	return is_blank	;
}

function update_vtr(id){
		temp 	= 	id.split("-")				;
		vtr_id	=	temp[temp.length -1 ]		;
		
		date 	=	new Date()					;
		time 	= ("0" + date.getHours()).slice(-2)  + ":"	+ ("0" + date.getMinutes()).slice(-2)	;
		
		attributes	=	{}			;
		
		atter_name				=	"service_vehicle_track[" + temp[0] + "]"	;
		atter_value				=	time		;
		attributes[atter_name]	= 	atter_value	;
		
		var path = "/service_vehicle_tracks/" + vtr_id ;
		$.ajax({	url: 		path,
					type: 		"put",
					data: 		attributes,
					dataType: 	"json", 
					success: 	function(result){ document.getElementById(id + "_dis").textContent = time	;	},
	    			error: 		function (jqXHR, text, errorThrown) {	alert(jqXHR.responseJSON.error)		;	}
    			});
		return true	;
}